import { useTranslation } from 'react-i18next';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import WorkerListWithPriority, { PrioritizedWorker } from '../../../../components/nors/WorkerListWithPriority';

const SMTPFields: React.FC<{
  formData: any;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  selectedWorkers: PrioritizedWorker[];
  setSelectedWorkers: (v: PrioritizedWorker[]) => void;
}> = ({ formData, onInputChange, selectedWorkers, setSelectedWorkers }) => {
  const { t } = useTranslation();

  return (
    <>
      <Form.Group as={Row} className="mb-3" controlId="smtpHost">
        <Form.Label column sm="2">
          Host
        </Form.Label>
        <Col sm="10">
          <Form.Control type="text" name="host" placeholder={t('enter') + ' host'} value={formData?.host || ''} onChange={onInputChange} />
        </Col>
      </Form.Group>

      <Form.Group as={Row} className="mb-3" controlId="smtpName">
        <Form.Label column sm="2">
          {t('name')}
        </Form.Label>
        <Col sm="10">
          <Form.Control type="text" name="name" placeholder={t('enter') + ' ' + t('name')} value={formData?.name || ''} onChange={onInputChange} />
        </Col>
      </Form.Group>

      <Form.Group as={Row} className="mb-3" controlId="smtpPort">
        <Form.Label column sm="2">
          {t('port')}
        </Form.Label>
        <Col sm="10">
          <Form.Control type="text" name="port" placeholder={t('enter') + ' ' + t('port')} value={formData?.port || ''} onChange={onInputChange} />
        </Col>
      </Form.Group>

      <Form.Group as={Row} className="mb-3" controlId="smtpEncryption">
        <Form.Label column sm="2">
          {t('encryption')}
        </Form.Label>
        <Col sm="10">
          <Form.Control
            type="text"
            name="encryption"
            placeholder={t('enter') + ' ' + t('encryption')}
            value={formData?.encryption || ''}
            onChange={onInputChange}
          />
        </Col>
      </Form.Group>

      <Form.Group as={Row} className="mb-3" controlId="smtpSecurity">
        <Form.Label column sm="2">
          {t('security')}
        </Form.Label>
        <Col sm="10">
          <Form.Control type="text" name="security" placeholder={t('enter') + ' ' + t('security')} value={formData?.security || ''} onChange={onInputChange} />
        </Col>
      </Form.Group>

      <Form.Group as={Row} className="mb-3" controlId="smtpUsername">
        <Form.Label column sm="2">
          {t('login.username')} ({t('common.optional')})
        </Form.Label>
        <Col sm="10">
          <Form.Control
            type="text"
            name="username"
            placeholder={t('enter') + ' ' + t('login.username')}
            value={formData?.username || ''}
            onChange={onInputChange}
          />
        </Col>
      </Form.Group>

      <Form.Group as={Row} className="mb-3" controlId="smtpPassword">
        <Form.Label column sm="2">
          {t('login.password')} ({t('common.optional')})
        </Form.Label>
        <Col sm="10">
          <Form.Control
            type="password"
            name="password"
            placeholder={t('enter') + ' ' + t('login.password')}
            value={formData?.password ? '••••••••' : ''}
            onChange={onInputChange}
          />
        </Col>
      </Form.Group>

      <WorkerListWithPriority selectedWorkers={selectedWorkers} setSelectedWorkers={setSelectedWorkers} />
    </>
  );
};

export default SMTPFields;
